import { BehaviorSubject } from 'rxjs';

const errorSubject = new BehaviorSubject({});
const ccSubject = new BehaviorSubject({});
const billingSubject = new BehaviorSubject({});
const nonInstantPaymentSubject = new BehaviorSubject({});

export const SubmitProcessValidationService = {
  setErrorMessage: (message: any) => errorSubject.next({ text: message }),
  getErrorMessage: (): any => errorSubject.getValue(),

  setCCInfo: (ccinfo: any, status: boolean) => ccSubject.next({ ccinfo, status }),
  getCCInfo: (): any => ccSubject.getValue(),
  onCCValidation: (): any => ccSubject.asObservable(),

  setBillingInfo: (billingInfo: any, errorStatus: boolean) =>
    billingSubject.next({ billingInfo, errorStatus }),
  getBillingInfo: (): any => billingSubject.getValue(),

  setNonInstantPaymentInfo: (paymentInfo: any, isValid: boolean) =>
    nonInstantPaymentSubject.next({ paymentInfo, isValid }),
  getNonInstantPaymentInfo: (): any => nonInstantPaymentSubject.getValue(),
  onNonInstantPaymentValidation: (): any => nonInstantPaymentSubject.asObservable(),
};

export default SubmitProcessValidationService;
